export const cyStateManager = {
  loading: false,
  elements: null,
};
